import {
  EquipUIFireflyV2Theme,
  MaudCardFrame,
  Text,
  TextInputV2,
} from '@equip.health/ui';
import { type RefCarePlanProblemResponse } from '~/lib/types/carePlan/RefCarePlanProblemResponse';
import {
  type CoOccurringProblemDetails,
  type ProblemDetails,
} from '~/components/maud/patients/profile/tabs/careplan/CarePlanProblemDialogManager';

const MISSING_DESCRIPTION_ERROR = 'Description is required';

export type ProblemDetailsCoOccurringCardProps = {
  details: CoOccurringProblemDetails;
  hasAttemptedSubmit?: boolean;
  idPrefix: string;
  problem: RefCarePlanProblemResponse;
  updateProblemDetails: (problemCode: string, next: ProblemDetails) => void;
};

export const ProblemDetailsCoOccurringCard = ({
  details,
  hasAttemptedSubmit = false,
  idPrefix,
  problem,
  updateProblemDetails,
}: ProblemDetailsCoOccurringCardProps) => {
  const showError = hasAttemptedSubmit && !details.description.trim();
  return (
    <MaudCardFrame id={`${idPrefix}-card-${problem.code}`}>
      <Text marginBottom="12px" variant="h5">
        {problem.label}
      </Text>
      <TextInputV2
        id={`${idPrefix}-description-${problem.code}`}
        isInvalid={showError}
        onChange={(newDescription) =>
          updateProblemDetails(problem.code, { description: newDescription })
        }
        placeholder="Add any additional context"
        value={details.description}
      />
      {showError && (
        <Text
          color={EquipUIFireflyV2Theme.colors.critical.base}
          id={`${idPrefix}-description-error-${problem.code}`}
          marginTop="6px"
          variant="bodyMedium"
        >
          {MISSING_DESCRIPTION_ERROR}
        </Text>
      )}
    </MaudCardFrame>
  );
};
